import Style from "./style"

import Search from "widget/Search"
import Pagenation from "widget/Pagenation"

import useGetFranchiseManagerList from "entity/franchise/useGetFranchiseManagerList"

import DefaultModal from "shared/ui/DefaultModal"
import DefaultButton from "shared/ui/DefaultButton"
import TStyle from "shared/style/tableStyle"

const FranchiseModal = ({ closeEvent, setFranchiseData }) => {

    const [franchiseList] = useGetFranchiseManagerList()

    const sizeList = ["short", "expand", "medium", "long", "short"]
    const tableHeadList = ["IDX", "이름", "대표 연락처", "매니저", ""]

    const selectFranchiseEvent = (data) => {
        setFranchiseData(data)
        closeEvent()
    }

    return (
        <DefaultModal title={"프렌차이즈 검색"} closeEvent={closeEvent}>
            <Style.Wrapper>
                <Search placeholder="대회 시리즈 이름에 포함되는 글자로 검색" />

                <TStyle.TableDiv>
                    <TStyle.TableRow $title>
                        {tableHeadList.map((elem, index) =>
                            <TStyle.Data $title $size={sizeList[index]}>{elem}</TStyle.Data>
                        )}
                    </TStyle.TableRow>
                    {franchiseList?.data?.franchise_list?.map((elem, index) =>
                        <TStyle.TableRow $odd={index % 2 === 1}>
                            <TStyle.Data $size={sizeList[0]}>{elem?.idx}</TStyle.Data>
                            <TStyle.Data $size={sizeList[1]}>{elem?.franchise_name}</TStyle.Data>
                            <TStyle.Data $size={sizeList[2]}>{elem?.franchise_contact}</TStyle.Data>
                            <TStyle.Data $size={sizeList[3]}>{elem?.name}</TStyle.Data>
                            <TStyle.Data $size={sizeList[4]}>
                                <DefaultButton small fitWidth clickEvent={() => selectFranchiseEvent(elem)}>선택</DefaultButton>
                            </TStyle.Data>
                        </TStyle.TableRow>
                    )}
                </TStyle.TableDiv>

                <Pagenation maxPage={1} />
            </Style.Wrapper>
        </DefaultModal>
    )
}

export default FranchiseModal